import { getRequest } from '../common/utils'

export function getHistoryData(params, criteria) {
    const { iotId, id } = params
    return getRequest(`/iotDataSummary/${iotId}/${id}`, criteria)
}
